module.exports = __webpack_public_path__ + "img/apple-1.4537397f.png";